<div class="modal-overlay-fp">
  <div class="card modal-full-width border-0">
    <div class="card-header bergh-bg-primary text-white h5">
      {{ firePartitionData.code }}
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-12">
          <ul class="nav nav-tabs">
            @for (tab of tabs; track tab) {
            <li class="nav-item">
              <a
                class="nav-link"
                [ngClass]="{
                  'text-muted': selectedTab != tab,
                  'bergh-text-primary': selectedTab === tab,
                  active: selectedTab === tab
                }"
                (click)="changeTab(tab)"
                id="tab-{{ tab }}"
                >{{ tab }}</a
              >
            </li>
            }
          </ul>
        </div>
      </div>
      @if (selectedTab === tabs[0] || selectedTab === tabs[1]) {
      <div class="row">
        <div class="col-12">
          <bergh-list-view [data]="tableData"></bergh-list-view>
        </div>
      </div>
      } @if (selectedTab === tabs[2]) {
      <div class="row">
        <div class="col-12">
          <bergh-image-gallery
            [data]="imageData"
            [pictures]="firePartitionData.pictures"
            (updateDeletePictureStatus)="updatePictures($event)"
            [firePartitionId]="firePartitionData._id"
          ></bergh-image-gallery>
        </div>
      </div>
      } @if (selectedTab === tabs[3]) {
      <div class="row">
        <div class="col-12">
          <bergh-edit-materials
            [materials]="firePartitionData.materials"
            [firePartitionId]="firePartitionData._id"
            [facilityType]="firePartitionData.facilityType"
            [firePartitionType]="firePartitionData.type"
            (updateSaveMaterialsStatus)="updateMaterials($event)"
            [saveMaterialsStatus]="saveMaterialsEvent"
            (flaggedDirty)="materialsDirty = true"
          >
          </bergh-edit-materials>
        </div>
      </div>
      } @if (selectedTab === tabs[4]) {
      <div class="row">
        <div class="col-12">
          <bergh-fp-documents
            [firePartitionId]="firePartitionData._id"
            [projectId]="projectId"
          ></bergh-fp-documents>
        </div>
      </div>
      }
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      @if (selectedTab === tabs[3] && !isSealPage && !isCustomer) {
      <button
        [disabled]="!materialsDirty"
        class="btn btn-primary mr-2"
        id="btn-save"
        (click)="saveMaterial()"
      >
        Materiaal opslaan
      </button>
      }
      <button
        class="btn btn-secondary mr-2"
        id="btn-cancel"
        (click)="cancel.emit()"
      >
        Sluiten
      </button>
    </div>
  </div>
</div>
